export const YEARS_SEARCH_PARAMS = "year";
export const TOPICS_SEARCH_PARAMS = "topics";
